import { DS } from '../../design-system'
import React from 'react'
import { TouchableOpacity } from 'react-native'
import { useStore } from '../../models'
import { observer } from 'mobx-react-lite'
import { useThrottledCallback } from 'use-debounce'
import { events } from '../../models/analytics/analytics-events'

import { useCheatSheet } from '../../components/CheatSheet/useCheatSheet'
import { excludeFromStepper } from '../../models/game/first-game/MyFirstGameUtils'
import MyFirstGameStepNames from '../../models/game/first-game/MyFirstGameStepNames'
import MyFirstGameSteps from '../../models/game/first-game/MyFirstGameSteps'
import { getRouteToLastVisitedTab } from '../../navigation'
import { LastVisitedTab } from '@/models/session/session-user'
import { useRouter } from 'expo-router'
import { useDrawerStore } from '@/components/Drawer/Drawer'
import { useIsEmbeddedSegment } from '@/hooks/useIsEmbeddedSegment'
import { View } from 'react-native'
import { LayoutShiftAnchor } from '@/hooks/useLayoutShiftRegistry'

const MyFirstGameStepper = observer(({ lastPage = 'home' }: { lastPage: LastVisitedTab }) => {
  const router = useRouter()
  const isEmbedded = useIsEmbeddedSegment()
  const {
    analytics: { setEvent },
    session: { user },
    game: { firstGameStage, setIsMyFirstGame, resetFirstGame }
  } = useStore()

  const { open: handleOpenCheatSheet } = useCheatSheet()

  const onOpenCheatSheet = useThrottledCallback(() => {
    handleOpenCheatSheet()
    setEvent(events.homescreen.cheat_sheet, {
      //todo: change event name?
      userId: user?._id.toString()
    })
  }, 1000)

  const onClose = () => {
    resetFirstGame()
    setIsMyFirstGame(false)

    setEvent('First Game Exited', {
      source: 'x top nav'
    })

    router.replace(getRouteToLastVisitedTab(lastPage))
  }

  return (
    <View style={{ padding: 16, paddingBottom: 0, zIndex: 5 }}>
      {firstGameStage < MyFirstGameSteps.length - 1 && (
        <DS.Frame style={{ flexDirection: 'row', gap: 4 }}>
          {MyFirstGameSteps.filter(
            (x) => !excludeFromStepper.includes(x.internalName ?? MyFirstGameStepNames.default)
          ).map((_, index) => {
            if (!MyFirstGameSteps[firstGameStage]) {
              return null
            }

            const stepperNumber = MyFirstGameSteps[firstGameStage].stepperNumber ?? 0

            return (
              <DS.Frame
                key={`slide-${index}`}
                style={{
                  flex: 1,
                  height: 2,
                  backgroundColor: index < stepperNumber ? '#F6F2E9' : '#822852'
                }}
              />
            )
          })}
        </DS.Frame>
      )}
      <View style={{ flexDirection: 'row', alignSelf: 'flex-end', gap: 8, marginTop: 8 }}>
        {firstGameStage === 0 || firstGameStage >= MyFirstGameSteps.length - 1 ? (
          isEmbedded ? null : (
            <TouchableOpacity
              style={{
                marginTop: 8,
                width: 40,
                height: 40,
                padding: 8,
                borderRadius: 24,
                backgroundColor: '#4A0225',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9
              }}
              onPress={onClose}
              hitSlop={10}
            >
              <DS.Icon name="Close" size={20} color="Global/White" />
            </TouchableOpacity>
          )
        ) : (
          <>
            <LayoutShiftAnchor name="myFirstGame.stepper.handRanking">
              <TouchableOpacity
                style={{
                  marginTop: 8,
                  width: 40,
                  height: 40,
                  padding: 8,
                  borderRadius: 24,
                  backgroundColor: '#4A0225',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
                onPress={onOpenCheatSheet}
              >
                <DS.Icon name="Key" size={20} color="Global/White" />
              </TouchableOpacity>
            </LayoutShiftAnchor>
            {!isEmbedded && (
              <TouchableOpacity
                style={{
                  marginTop: 8,
                  width: 40,
                  height: 40,
                  padding: 8,
                  borderRadius: 24,
                  backgroundColor: '#4A0225',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
                onPress={() => {
                  useDrawerStore.getState().toggleDrawer()
                }}
              >
                <DS.Icon name="HamburgerMenu" size={20} color="Global/White" />
              </TouchableOpacity>
            )}
          </>
        )}
      </View>
    </View>
  )
})

export default MyFirstGameStepper
